import { useEffect, useState } from 'react'

export const useIsMounted = (): boolean => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [typeof window])

  return isMounted
}
